import * as defaultImport from "@splunk/ui-utils/i18n";
export * from "@splunk/ui-utils/i18n";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
